/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WorkspacesContainer_node$ref: FragmentReference;
export type WorkspacesContainer_node = {|
  +id: string,
  +title: ?string,
  +start_at: ?any,
  +end_at: ?any,
  +time_zone: ?string,
  +can_edit: ?boolean,
  +user_contacts: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +first_name: ?string,
        +last_name: ?string,
        +user_contact_emails: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +address: ?string
            |}
          |}>
        |},
      |}
    |}>
  |},
  +user_event: ?{|
    +start_at: ?any,
    +end_at: ?any,
    +time_zone: ?string,
  |},
  +workspaces: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: ?string,
        +share_token: ?string,
        +permissions: ?$ReadOnlyArray<?string>,
        +can_email: ?boolean,
        +estimates: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +invoices: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +forms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
            |}
          |}>
        |},
        +music_planners: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
              +can_edit: ?boolean,
            |}
          |}>
        |},
        +contracts: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +title: ?string,
              +editable: ?boolean,
              +contract_signature_blocks: ?{|
                +edges: ?$ReadOnlyArray<?{|
                  +node: ?{|
                    +signed_at: ?any
                  |}
                |}>
              |},
            |}
          |}>
        |},
        +wuploads: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +mimetype: ?string,
              +name: ?string,
              +url: ?string,
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$refType: WorkspacesContainer_node$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "count": null,
  "cursor": null,
  "direction": "forward",
  "path": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "time_zone",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "can_edit",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v9 = [
  v1,
  v2,
  v8
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "WorkspacesContainer_node",
  "type": "Event",
  "metadata": {
    "connection": [
      v0,
      v0,
      v0,
      v0,
      v0,
      v0,
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "workspaces"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    v1,
    v2,
    v3,
    v4,
    v5,
    v6,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user_contacts",
      "storageKey": "user_contacts(first:99999)",
      "args": v7,
      "concreteType": "EventUserContactConnectionWithRole",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "EventUserContactEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserContact",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "first_name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "last_name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_contact_emails",
                  "storageKey": "user_contact_emails(first:99999)",
                  "args": v7,
                  "concreteType": "UserContactEmailConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserContactEmailEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserContactEmail",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "address",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user_event",
      "storageKey": null,
      "args": null,
      "concreteType": "UserEvent",
      "plural": false,
      "selections": [
        v3,
        v4,
        v5
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "workspaces",
      "name": "__WorkspacesContainer_workspaces_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkspaceConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "WorkspaceEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Workspace",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": "invoices",
                  "name": "__EventShowContainer_invoices_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "InvoiceConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "InvoiceEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Invoice",
                          "plural": false,
                          "selections": v9
                        },
                        v10
                      ]
                    },
                    v11
                  ]
                },
                v1,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "share_token",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "permissions",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "can_email",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": "estimates",
                  "name": "__EventShowContainer_estimates_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "EstimateConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "EstimateEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Estimate",
                          "plural": false,
                          "selections": v9
                        },
                        v10
                      ]
                    },
                    v11
                  ]
                },
                v2,
                {
                  "kind": "LinkedField",
                  "alias": "forms",
                  "name": "__WorkspacesContainer_forms_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "FormConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "FormEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Form",
                          "plural": false,
                          "selections": v9
                        },
                        v10
                      ]
                    },
                    v11
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "music_planners",
                  "name": "__WorkspacesContainer_music_planners_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "MusicPlannerConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "MusicPlannerEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "MusicPlanner",
                          "plural": false,
                          "selections": [
                            v1,
                            v2,
                            v6,
                            v8
                          ]
                        },
                        v10
                      ]
                    },
                    v11
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "contracts",
                  "name": "__EventShowContainer_contracts_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ContractConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ContractEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Contract",
                          "plural": false,
                          "selections": [
                            v1,
                            v2,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "editable",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "contract_signature_blocks",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ContractSignatureBlockConnection",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "edges",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "ContractSignatureBlockEdge",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "node",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "ContractSignatureBlock",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "ScalarField",
                                          "alias": null,
                                          "name": "signed_at",
                                          "args": null,
                                          "storageKey": null
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            },
                            v8
                          ]
                        },
                        v10
                      ]
                    },
                    v11
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": "wuploads",
                  "name": "__WorkspacesContainer_wuploads_connection",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "WuploadConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "WuploadEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Wupload",
                          "plural": false,
                          "selections": [
                            v1,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "mimetype",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "name",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "url",
                              "args": null,
                              "storageKey": null
                            },
                            v8
                          ]
                        },
                        v10
                      ]
                    },
                    v11
                  ]
                },
                v8
              ]
            },
            v10
          ]
        },
        v11
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '5181045c8217443acf63593ec3d77168';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/Workspace/__generated__/WorkspacesContainer_node.graphql.js